'use es6';

import { TemplateFilters } from 'ContentUtils/constants/ThemeFilters';
import { TemplateSourceFilters } from 'ContentUtils/constants/TemplateSourceFilters';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { ROOT_FOLDER } from './TemplateList';
import { FilterBar, SearchInput, SortFilter } from './FilterBar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.themes.filterBar.${key}`;
const TemplateSourceFilter = ({
  sourceFilter,
  onSourceFilterChange
}) => /*#__PURE__*/_jsxs(TFlex, {
  alignItems: "center",
  children: [/*#__PURE__*/_jsx(FormattedMessage, {
    message: i18nKey('sourceFilterLabel')
  }), /*#__PURE__*/_jsx(Select, {
    buttonUse: "link",
    value: sourceFilter,
    options: [{
      text: I18n.text(i18nKey('sourceFilters.all')),
      value: TemplateSourceFilters.ALL
    }, {
      text: I18n.text(i18nKey('sourceFilters.custom')),
      value: TemplateSourceFilters.CUSTOM
    }, {
      text: I18n.text(i18nKey('sourceFilters.hubspot')),
      value: TemplateSourceFilters.HUBSPOT
    }, {
      text: I18n.text(i18nKey('sourceFilters.purchased')),
      value: TemplateSourceFilters.PURCHASED
    }, {
      text: I18n.text(i18nKey('sourceFilters.starter')),
      value: TemplateSourceFilters.STARTER
    }],
    onChange: onSourceFilterChange,
    menuWidth: 200,
    marginInlineStart: "200"
  })]
});
const TemplateFolderFilter = ({
  folderName,
  onFolderNameChange,
  templateFolders
}) => {
  const folders = templateFolders.filter(folder => folder && !folder.includes('@hubspot/'));
  return Boolean(folders.length) && /*#__PURE__*/_jsxs(TFlex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('folderLabel')
    }), /*#__PURE__*/_jsx(Select, {
      buttonUse: "link",
      value: folderName,
      options: [{
        text: I18n.text(i18nKey('allFolders')),
        value: ROOT_FOLDER
      }, ...folders.map(folder => ({
        text: folder,
        value: folder
      }))],
      onChange: onFolderNameChange,
      menuWidth: 200,
      marginInlineStart: "200"
    })]
  });
};
export const TemplateFilterBar = ({
  searchValue,
  sortType,
  sourceFilter,
  folderName,
  templateFolders,
  type,
  onSearchChange,
  onSortingChange,
  onSourceFilterChange,
  onFolderNameChange
}) => {
  const isTemplateFilterType = Object.values(TemplateFilters).includes(type);
  return /*#__PURE__*/_jsx(FilterBar, {
    searchInput: /*#__PURE__*/_jsx(SearchInput, {
      placeholder: I18n.text(i18nKey('searchPlaceholder.template')),
      onChange: onSearchChange,
      searchValue: searchValue
    }),
    sortFilter: /*#__PURE__*/_jsx(SortFilter, {
      sortType: sortType,
      onSortingChange: onSortingChange
    }),
    sourceFilter: isTemplateFilterType ? /*#__PURE__*/_jsx(TemplateSourceFilter, {
      sourceFilter: sourceFilter,
      onSourceFilterChange: onSourceFilterChange
    }) : null,
    templateFolderFilter: isTemplateFilterType ? /*#__PURE__*/_jsx(TemplateFolderFilter, {
      folderName: folderName,
      onFolderNameChange: onFolderNameChange,
      templateFolders: templateFolders
    }) : null
  });
};